export const BASE_READ_URL = process.env.VITE_API_URL;
export const BASE_READ_PREVIEW_URL = process.env.VITE_API_PREVIEW_URL;
export const BASE_WRITE_URL = process.env.VITE_API_WRITE_URL || BASE_READ_URL;
export const URL_SUFFIX = process.env.VITE_API_URL_SUFFIX || '/';

// Read-only URLs that can be served from static content (GET requests)
export const PUBLIC_URL = `${BASE_READ_URL}/public/`;
export const PUBLIC_PREVIEW_URL = `${BASE_READ_PREVIEW_URL}/public/`;
export const COMPANY_URL = `${BASE_READ_URL}/company/`;

// Write URLs that need to point to a functional backend (POST)
export const APPLY_URL = `${BASE_WRITE_URL}/apply/`;
